import { createSaga } from './saga-helpers';

import * as Api from '../api/app-props-api';

const watchGetAppProps = createSaga({
    type: 'APP_PROPS_FETCH',
    fn: Api.fetchAppProps,
    successPayload: (props) => ({ props })
});

const watchUserDetailedActivate = createSaga({
    type: 'USER_DETAILED_ACTIVATE',
    fn: Api.activateUserDetailed,
    args: action => [action.payload.userId, action.payload.type, action.payload.tab]
});

const watchUserDetailedDeactivate = createSaga({
    type: 'USER_DETAILED_DEACTIVATE',
    fn: Api.deactivateUserDetailed
});

const appPropsSagas = [watchGetAppProps, watchUserDetailedDeactivate, watchUserDetailedActivate];

export default appPropsSagas;
